export default __webpack_public_path__ + "static/media/Group 26759.f2b3c943.svg";